import { computed, toRefs } from 'vue'

import { useBem } from '@ga/bem'

export const useImage = (props, { emit }) => {
  const b = useBem()

  const { className, src, sources, lazy } = toRefs(props)

  const buildMedia = (media) => {
    if (!media) {
      return null
    }

    const from = media.from && `(min-width: ${media.from}px)`
    const till = media.till && `(max-width: ${media.till - 1}px)`

    return [from, till].filter(Boolean).join(' and ')
  }

  const buildSrcset = (srcset) => {
    return srcset.length > 1
      ? srcset.map((source, index) => `${source} ${index + 1}x`).join(', ')
      : srcset[0]
  }

  const buildType = (ext = 'jpeg') => {
    return `image/${ext}`.toLowerCase()
  }

  const rootClass = computed(() => [b(), className.value])

  const sourcesInternal = computed(() =>
    sources.value.map(({ media, srcset, ext }) => ({
      media: buildMedia(media),
      srcset: buildSrcset(srcset),
      type: buildType(ext),
    })),
  )

  const hasSourcesInternal = computed(() => sourcesInternal.value.length > 0)

  const imgAttrs = computed(() => ({
    src: src.value,
    loading: lazy.value && 'lazy',
  }))

  const onLoad = ($event) => {
    emit('load', $event)
  }

  const onError = ($event) => {
    emit('error', $event)
  }

  return {
    b,

    imgAttrs,
    hasSourcesInternal,
    sourcesInternal,
    rootClass,

    onLoad,
    onError,
  }
}
